/**
 * FipaListener that mimicks like its node.js EventEmitter but uses browser's event listeners
 * Event listeners are all added into window target
 */
class FipaListener {
    constructor() { }
    /**
     * Adds new eventListener
     * @param eventName event name
     * @param method function
     * @param options optional options that addEventListener supports
     */
    on(eventName, 
    // eslint-disable-next-line no-unused-vars
    method, 
    // eslint-disable-next-line no-undef
    options) {
        if (!eventName)
            throw "FipaListener.on missing eventName";
        window.addEventListener("fipa:" + eventName, method, options);
    }
    /**
     * Removes added event listener
     * @param eventName event name
     * @param method function that was used to add event listener
     * @param options required if have provided { capture: true } or boolean true
     */
    off(eventName, 
    // eslint-disable-next-line no-unused-vars
    method, 
    // eslint-disable-next-line no-undef
    options) {
        if (!eventName)
            throw "FipaListener.off missing eventName";
        window.removeEventListener("fipa:" + eventName, method, options);
    }
    /**
     * Dispatches event to be triggered
     * @param eventName event name to trigger
     * @param detail data to provide to event's method. Accessible trough event.detail property
     */
    emit(eventName, detail) {
        if (!eventName)
            throw "FipaListener.emit missing eventName";
        window.dispatchEvent(new CustomEvent("fipa:" + eventName, { detail }));
    }
}
export default new FipaListener();
